<script lang="ts">
    import KpClassicTable from 'shared/ui-widgets/table/classic/KpClassicTable.svelte';
    import {fade} from 'svelte/transition';

    export let fixedLayout = false;
</script>

<div class="table-wrapper" in:fade>
    <KpClassicTable additionalClasses="kp-search-result-table {fixedLayout ? 'fixed-layout' : ''}"
                    responsive
                    horizontallyDivided
                    hoverRows
                    colorAccented
                    bordered
                    columnHeadersCentered>

        <slot name="header" slot="header"/>
        <slot name="body" slot="body"/>
    </KpClassicTable>
</div>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    @table-header-footer-height: 48px;
    @table-data-padding: 8px 10px;

    .table-wrapper {
        margin: @padding-large-vertical 0;
    }

    :global {
        .kp-search-result-table {
            &.fixed-layout {
                table-layout: fixed;
            }

            tr > th,
            tr > td {
                padding: @table-data-padding !important;
            }

            tr > th {
                height: @table-header-footer-height;
            }

            tr > td:not(.not-centered-td) {
                text-align: center;
                vertical-align: middle;
            }
        }
    }
</style>